"use strict";

const Filters = () => {
    const init = () => {
        $(function() {
            var $forms = $('.js-filters-form');
            if ($forms.length > 0) {
                $forms.each(function(){
                    var $form = $(this);
                    var $radios = $form.find('.js-radio');
                    var $checkboxes = $form.find('.js-checkbox');
                    var $textSelect = $form.find('.js-text-select');
                    var $postcode = $form.find('.js-postcode-input');
                    var $modeToggle = $('.js-mode-toggle');
                    var $advancedToggle = $('.js-filters-advanced-toggle');
                    
                    $radios.on('click', function(e){
                        e.preventDefault();
                        var $input = $(this).find('input');
                        if($input.is(':checked')){
                            $input.prop('checked', false);
                        }else{
                            $radios.filter('[data-name="'+$(this).data('name')+'"]').find('input').prop('checked', false);
                            $input.prop('checked', true);
                        }
                        if($(this).hasClass('js-disable-other-form-groups')){
                            disableFormGroups($(this), true);
                        }
                        $form.find('[name="page"]').val(1);
                        $form.find('.ajax-submit').trigger('click');
                        if($(this).data('slug') !== undefined) {
                            window.history.pushState({}, "", window.location.protocol + '//' + window.location.host + '/' + $(this).data('slug'));
                        }
                    });
                    
                    $checkboxes.on('click', function(){
                        var $input = $(this).find('input');
                        if($input.is(':checked')){
                            $input.prop('checked', false);
                        }else{
                            $input.prop('checked', true);
                        }
                        $form.find('[name="page"]').val(1);
                        $form.find('.ajax-submit').trigger('click');
                    });

                    $form.find('input[type="text"]:not(.js-text-select-input)').on('change', function(){
                        $form.find('[name="page"]').val(1);
                        $form.find('.ajax-submit').trigger('click');
                    });

                    $form.find('.checkbox input').on('change', function(){
                        $form.find('[name="page"]').val(1);
                        $form.find('.ajax-submit').trigger('click');
                    });

                    $('.js-filters-reset').on('click', function(){
                        $radios.find('input').prop('checked', false);
                        $checkboxes.find('input').prop('checked', false);
                        $form.find('.checkbox input[type="checkbox"]').prop('checked', false);
                        $form.find('.nice-select').val('');
                        $form.find('.nice-select').niceSelect('update');
                        $form.find('input[type="text"]').val('');
                        $form.find('.filled, .focused').removeClass('filled focused');
                        $form.find('[name="page"]').val(1);
                        $form.find('.ajax-submit').trigger('click');
                    });

                    $textSelect.find('.js-text-select-input').on('keyup', function(){
                        var $this = $(this)
                        var $parent = $this.parents('.js-text-select')
                        if($this.val() !== '') {
                            var foundOne = false;

                            $this.siblings('.js-text-select-options').addClass('open');

                            $parent.find('.js-text-select-option').each(function(){
                                if($(this).data('value').toLowerCase().indexOf($this.val().toLowerCase()) >= 0){
                                    $(this).show();
                                    foundOne = true;
                                }else{
                                    $(this).hide();
                                }
                            });

                            if(!foundOne){
                                $this.siblings('.js-text-select-options').removeClass('open');
                            }
                        }else{
                            $this.siblings('.js-text-select-options').addClass('open');
                            $parent.find('.js-text-select-option').show();
                        }
                    });

                    $textSelect.find('.js-text-select-input').on('click', function(){
                        var $this = $(this);

                        var $parent = $this.parents('.js-text-select')
                        $this.siblings('.js-text-select-options').addClass('open');
                        var foundOne = false;

                        $parent.find('.js-text-select-option').each(function(){
                            if($(this).data('value').toLowerCase().indexOf($this.val().toLowerCase()) >= 0){
                                $(this).show();
                                foundOne = true;
                            }else{
                                $(this).hide();
                            }
                        });

                        if ($this.val().trim() == '') {
                            foundOne = true
                        }

                        if(!foundOne){
                            $this.siblings('.js-text-select-options').removeClass('open');
                        }
                    });
                    
                    $textSelect.find('.js-text-select-option').on('click', function(){
                        var $this = $(this);
                        $this.parents('.js-text-select').find('.js-text-select-input').val($this.data('value'));
                        $this.parents('.js-text-select').addClass('filled');
                        $this.parents('.js-text-select-options').removeClass('open');
                        $form.find('[name="page"]').val(1);
                        $form.find('.ajax-submit').trigger('click');
                    });

                    $(window).click(function(e) {
                        if(!$(e.target).hasClass('js-text-select') && !$(e.target).parents('.js-text-select').length){
                            $textSelect.find('.js-text-select-options').removeClass('open');
                        }
                    });

                    $form.find('.js-filters-extra-toggle').on('click', function(){
                        $form.find('.js-filters-extra').slideToggle();
                        $form.find('.js-filters-spacer').slideToggle();
                    });

                    $modeToggle.on('click', function(){
                        $modeToggle.removeClass('active');
                        $(this).addClass('active');
                        $(this).parents('.js-map-holder').removeClass('list-view map-view');
                        $(this).parents('.js-map-holder').addClass($(this).data('id')+'-view');
                        $form.find('[name="mode"]').val($(this).data('id'));
                        $form.find('.ajax-submit').trigger('click');
                    });

                    $advancedToggle.on('click', function(){
                        let $this = $(this);
                        if($this.hasClass('active')){
                            $this.removeClass('active');
                            $form.find('.js-filters-advanced').slideUp();
                        }else{
                            $this.addClass('active');
                            $form.find('.js-filters-advanced').slideDown();
                        }
                    });

                    if($postcode.length){
                        if (navigator.geolocation) {
                            function success(position){
                                $.get('https://maps.googleapis.com/maps/api/geocode/json?latlng='+position.coords.latitude+','+position.coords.longitude+'&key='+$postcode.data('key'), function(data){
                                    if(data.results.length){
                                        var postcode = data.results[0].address_components.pop()
                                        var types = postcode.types;
                                        if($.inArray('postal_code', types) !== -1) {
                                            $postcode.val(postcode.long_name);
                                            $postcode.parents('.form-group').addClass('filled');
                                        }
                                    }
                                    if($form.hasClass('js-submit-on-geolocation')){
                                        $form.find('.ajax-submit').trigger('click');
                                    }
                                });
                            };
                            function error(position){
                                console.log(position);
                            };
                            navigator.geolocation.getCurrentPosition(success, error);
                        }
                    }

                    $form.find('.js-submit-get-form').on('click', function(){
                        location.href=$(this).data('url') + '?' + ($(window).width() >= 1200 ? 'per_page=10&' : '') + getParamsFromForm($form);
                    });

                    $form.find('.ajax-submit').on('click', function(){
                        if($form.hasClass('js-update-url')){
                            var model = {}; 
                            $.map($form.serializeArray(), function (n, i) {
                                if(n['value'] !== ''){
                                    if(model[n['name']] !== undefined && Array.isArray(model[n['name']])){
                                        if(n['value'] !== ''){
                                            model[n['name']].push(n['value']);
                                        }
                                    }else if(model[n['name']] !== undefined){
                                        model[n['name']] = [model[n['name']], n['value']]
                                    }else{
                                        model[n['name']] = n['value'];
                                    }
                                }
                            });
                            $.each(model, function(k,v){
                                if(v === '' || v == 0){
                                    delete model[k];
                                }
                            });
                            history.pushState({}, null, window.location.pathname + '?' + decodeURIComponent(new URLSearchParams(model).toString()));
                        }
                        ttq.track('Search', {
                            "contents": [
                                {
                                    "content_id": window.location.href,
                                    "content_type": "Search",
                                    "content_name": document.title
                                }
                            ],
                            "query": $form.serialize()
                        })
                    });

                    function disableFormGroups($this, submit){
                        let $parent = $this.parents('.form-group');
                        if($this.find('input').prop('checked')){
                            $parent.siblings('.form-group:not(.reset)').addClass('disabled');
                            $radios.filter(':not(.js-disable-other-form-groups)').find('input').prop('checked', false);
                            $checkboxes.find('input').prop('checked', false);
                            $form.find('.checkbox input[type="checkbox"]').prop('checked', false);
                            $form.find('.nice-select').val('');
                            $form.find('.nice-select').niceSelect('update');
                            $form.find('input[type="text"]').val('');
                            $form.find('.filled, .focused').removeClass('filled focused');
                            if(submit){
                                $form.find('[name="page"]').val(1);
                                $form.find('.ajax-submit').trigger('click');
                            }
                        }else{
                            $parent.siblings('.form-group:not(.reset)').removeClass('disabled');
                        }
                    }

                    disableFormGroups($form.find('.js-disable-other-form-groups'), false);
                });
                
                $('.js-filters-toggle').on('click', function(){
                    $(this).siblings('.filters').addClass('open');
                    $(this).siblings('.js-filters-form').find('.filters').addClass('open');
                });
    
                $('.js-filters-close').on('click', function(){
                    $(this).parents('.filters').removeClass('open');
                    $('html, body').animate({
                        scrollTop: $(this).parents('.js-filters-form').offset().top
                    }, 100);
                });

                $('.js-filters-sort').on('change', function(){
                    $('.js-filters-form input[name="sort"]').val($(this).val());
                    $forms.find('[name="page"]').val(1);
                    $('.js-filters-form .ajax-submit').trigger('click');
                });

                $('.js-filters-back-to-top').on('click', function(){
                    $('html, body').animate({
                        scrollTop: $forms.parents('.filters').offset().top
                    }, 100);
                });

                $(window).resize(function() {
                    if($('.js-filters-extra:visible').length){
                        $('.js-filters-spacer').css('height', $('.js-filters-extra').outerHeight() + 'px');
                    }else{
                        $('.js-filters-extra').show();
                        $('.js-filters-spacer').css('height', $('.js-filters-extra').outerHeight() + 'px');
                        $('.js-filters-extra').css('display', '');
                    }
                })

                $(window).trigger('resize');

                var alreadyAsked = false;
                window.askUserToChangeState = function(state, url){
                    if(!alreadyAsked){
                        alreadyAsked = true;
                        if (confirm('You entered a postcode from ' + state.toUpperCase() + '. Do you want to view Display Homes from ' + state.toUpperCase() + '?') == true) {
                            location.href=url;
                        }
                    }
                }

                $('.js-estate').on('click', function(){
                    var $estatesForm = $('.js-filters-form');
                    var $estateFilter = $estatesForm.find('[name="estate"]');
                    $estateFilter.val($(this).data('slug'));
                    $estateFilter.niceSelect('update');
                    $estatesForm.find('[name="page"]').val(1);
                    $estatesForm.find('.ajax-submit').trigger('click');
                    if($(window).scrollTop() <= 0){
                        $('html, body').animate({
                            scrollTop: $estatesForm.offset().top
                        }, 100);
                    }
                });
            }

            if($('.js-per-page').length){
                $(window).on('resize', function(){
                    if($(window).width() >= 1200){
                        var perPage = 10;
                    }else{
                        var perPage = 9;
                    }
                    updatePerPage(perPage);
                });
            }

            window.updatePerPage = function(perPage){
                var $perPage = $('.js-per-page');

                if($perPage.length){
                    $perPage.each(function(){
                        var href = $(this).attr('href');
                        var paramsArray = href.split('?');
                        if(paramsArray.length > 1){
                            var hrefParams = new URLSearchParams(href.split('?').pop());
                            hrefParams.delete('per_page');
                            $(this).attr('href', href.split('?')[0] + '?' + decodeURIComponent(new URLSearchParams(hrefParams).toString()) + '&per_page=' + perPage);
                        }else{
                            $(this).attr('href', href + '?per_page=' + perPage);
                        }
                    });
                }
            }
        });

        function getParamsFromForm($form){
            var model = {}; 
            $.map($form.serializeArray(), function (n, i) {
                if(model[n['name']] !== undefined && Array.isArray(model[n['name']])){
                    model[n['name']].push(n['value']);
                }else if(model[n['name']] !== undefined){
                    model[n['name']] = [model[n['name']], n['value']]
                }else{
                    model[n['name']] = n['value'];
                }
            });
            $.each(model, function(k,v){
                if(v === ''){
                    delete model[k];
                }
            });
            return decodeURIComponent(new URLSearchParams(model).toString());
        }
    };

    return {
        init:init
    };
};

export default Filters;